import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useAppSelector } from './hooks.js';
import Shell from '../features/shell/Shell.js';
import { selectColorMode } from '../store/selectors/index.js';
import { darkTheme, lightTheme } from '../theme/okTheme.js';

export default function App() {
  const mode = useAppSelector(selectColorMode);
  return (
    <ThemeProvider theme={mode === 'dark' ? darkTheme : lightTheme}>
      <CssBaseline />
      <Shell />
    </ThemeProvider>
  );
}
